// Dis uygulama tanimlari. Sidebar altinda "Diger Uygulamalar" bolumunde
// gorunur; kullanici tikladiginda SSO token ile yeni sekmede acilir.
//
// Yeni bir uygulama eklemek icin bu dosyaya bir kayit eklemek yeterli
// (Ayarlar > External Apps CRUD YOK — tek kaynak burasi). Kayit ekledikten
// sonra:
//   - Sidebar otomatik render eder
//   - openExternalApp helper SSO token'i alip yeni sekmede acar
//   - Backend'e o app icin ayrica bir sey yapmaya gerek yok (target_app
//     alani ile sso_tokens tablosunda ayirt edilir)

// icon: MUI icon component'i (RocketLaunchIcon vb.). Basit logo goruntusu
//   icin `logo` alani bir public URL string tasir; ikon yerine `<img />`
//   render edilir. Ikisinden birini vermek yeter.
// color: kart/hover rengi (menude arka plan tint icin).
// code: backend'de sso_tokens.target_app alanina yazilir. Snake_case.
// baseUrl: SSO callback dahil root URL. Kullanici sekmeye gitti:
//   ${baseUrl}${ssoCallbackPath}?token=<one_time_sso_token>
// ssoCallbackPath: hedef uygulamanin SSO handler endpoint'i.
export const EXTERNAL_APPS = [
  {
    code: 'argenet',
    name: 'AR-GE NET',
    description: 'Ar-Ge proje yönetim platformu',
    // Logo public/argenet.png; sidebar'da 20x20 img olarak render.
    logo: '/argenet.png',
    color: '#7c3aed',
    baseUrl: 'https://argenet.aithinks.net',
    ssoCallbackPath: '/sso/callback',
  },
];
